import Cookies from 'js-cookie';
export var getExpCookie = function getExpCookie() {
  return Cookies.get('exp');
};